import { useEffect, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { useGetImagePicker, useRemoveImage } from "core/hooks/useImagePicker";
import { ISelectedImage } from 'core/store/upload/actions';
import { RouterName, route } from "core/router";
import { useDispatch, useSelector } from "react-redux";
import {
  createCommunityRequest,
  resetCreateCommunity,
} from "../store/actions";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";

export const useGoToCreate = () => {
  const navigate = useCustomNavigate();
  const goToCreate = useCallback((postType?: 'community' | 'recipe', post?: any) => {
    if (post) {
      navigate(RouterName.COMMUNITY_CREATE, { state: { postType, post } })
    } else {
      navigate(RouterName.COMMUNITY_CREATE)
    }
  }, [navigate])

  return goToCreate;
};

export const useCreate = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useCustomNavigate();
  const [ post, setPost ] = useState<any | null>(location.state?.post || null);
  const [ canSelectImage, setCanSelectImage ] = useState<boolean>(false);
  const { data, loading, error } = useSelector(
    (state: any) => state.Community.create
  );
  const removeImage = useRemoveImage();

  const formik = useFormikCustom({
    initialValues: {
      content: "",
      images: [],
      images_id: [],
      post_share: location.state?.post?.id || '',
    },
    // validationSchema:validationSchemaForm,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values) {
      if (loading) return;
      dispatch(createCommunityRequest({
        content: values.content,
        file_ids: values.images_id,
        recipe_detail_id: location.state?.postType === 'recipe' ? location.state?.post?.id : null,
        shared_post_id: location.state?.postType === 'community' ? location.state?.post?.id : null,
      }))
    },
  });
  const communityImages = useGetImagePicker(
    'communityImages',
    true
  )

  useEffect(() => {
    return () => {
      dispatch(resetCreateCommunity())
      formik.resetForm()
    }
  }, [])

  useEffect(() => {
    if (data) {
      formik.values.images.forEach((e: string) => {
        removeImage(e)
      })
      if (data?.data?.id) {
        navigate(route(RouterName.POST_DETAIL, data.data?.id))
      } else {
        navigate(route(RouterName.COMMUNITY_LIST))
      }
    }
  }, [data])

  useEffect(() => {
    const imageUpload = communityImages.filter((e: ISelectedImage) => e.src)
    formik.setFieldValue('images', imageUpload.map((e: ISelectedImage) => e.uuid))
    formik.setFieldValue('images_id', imageUpload.map((e: ISelectedImage) => e.id))
  }, [communityImages])

  const onRemovePost = useCallback(() => {
    formik.setFieldValue('post_share', '')
    setPost(null)
  }, [])

  const toggleSelectImage = useCallback(() => {
    if (formik.values.images.length) {
      return
    }
    setCanSelectImage((prev) => !prev)
  }, [formik.values.images])

  return {
    formik,
    post,
    postType: location.state?.postType,
    onRemovePost,
    canSelectImage,
    toggleSelectImage,
    loading,
    error,
  };
};
